module.exports = __webpack_public_path__ + "fonts/Graphik-Regular-Web.ba3af1c.woff";